import React from 'react';
import { AxisBottom } from '@visx/axis';
import { scaleLinear } from '@visx/scale';
import { round } from 'lodash-es';
import { makeStyles } from '../styles';
import RangeSlider from '../RangeSlider';
import Box from '../Box';
import IconButton from '../IconButton';
import { P } from '../ContentTags';
import { ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, } from '../icons';
const useStyles = makeStyles(({ spacing, palette }) => ({
    gradScaleRoot: {
        margin: spacing(1),
    },
    axisRoot: {
        overflow: 'visible',
        height: spacing(2),
        width: '100%',
    },
    control: {
        margin: spacing(1, 'auto'),
    },
    thresholdValue: {
        color: palette.secondary.main,
        padding: spacing(0.25),
        margin: spacing(0.25),
        minWidth: spacing(5.5),
        textAlign: 'center',
    },
}));
const TINY_FACTOR = 1;
const INCREMENT_FACTOR = 10;
function GraduatedRangeSlider({ domain, onChange, rangeValues, step, precision = 3, }) {
    const classes = useStyles();
    const gradScale = React.useMemo(() => scaleLinear({
        range: [0, '100%'],
        clamp: true,
        domain,
    }), [domain]);
    const min = rangeValues[0];
    const max = rangeValues[0] ?? domain[0];
    const handleDecrement = (currentThreshold, type, factor) => {
        const decrementor = step * factor;
        let newValue = currentThreshold - decrementor;
        if (newValue < domain[0])
            [newValue] = domain;
        const values = type === 'min' ? [newValue, max] : [min, newValue];
        onChange(values);
    };
    const handleIncrement = (currentThreshold, type, factor) => {
        const incrementor = step * factor;
        let newValue = currentThreshold + incrementor;
        if (newValue > domain[1])
            [, newValue] = domain;
        const values = type === 'min' ? [newValue, max] : [min, newValue];
        onChange(values);
    };
    return (React.createElement("div", { className: classes.gradScaleRoot },
        React.createElement(RangeSlider, { domain: domain, onChange: onChange, rangeValues: rangeValues, step: step }),
        React.createElement("svg", { className: classes.axisRoot },
            React.createElement(AxisBottom, { top: 0, left: 0, hideAxisLine: true, scale: gradScale, tickLength: 4 })),
        React.createElement(Box, { width: "100%", justifyContent: "space-between" }, rangeValues.map((threshold, i) => {
            const thresholdType = i === 0 ? 'min' : 'max';
            return (React.createElement(Box, { key: thresholdType, width: "100%", justifyContent: "space-around", className: classes.control },
                React.createElement(IconButton, { onClick: () => handleDecrement(threshold, thresholdType, INCREMENT_FACTOR), icon: React.createElement(ChevronDoubleLeftIcon, { size: "xs" }) }),
                React.createElement(IconButton, { onClick: () => handleDecrement(threshold, thresholdType, TINY_FACTOR), icon: React.createElement(ChevronLeftIcon, { size: "xs" }) }),
                React.createElement(P, { className: classes.thresholdValue, variant: "body2", theme: "bold" }, round(threshold, precision)),
                React.createElement(IconButton, { onClick: () => handleIncrement(threshold, thresholdType, TINY_FACTOR), icon: React.createElement(ChevronRightIcon, { size: "xs" }) }),
                React.createElement(IconButton, { onClick: () => handleIncrement(threshold, thresholdType, INCREMENT_FACTOR), icon: React.createElement(ChevronDoubleRightIcon, { size: "xs" }) })));
        }))));
}
export default GraduatedRangeSlider;
//# sourceMappingURL=GraduatedRangeSlider.js.map